module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/project-abago.json
// module id = 357
// module chunks = 281014433019208